/**
 * Created by DejanK on 01/31/2020.
 */
import angular from 'angular';
import PublicLinkErrorHandler from 'root/components/molecules/PublicLinkErrorHandler/PublicLinkErrorHandler.cmp.js';

export default angular.module('rb.ng-svelte-components', [])
  .component('rbSngPublicLinkErrorHandler', PublicLinkErrorHandler);
